var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#eaeaea;}")),React.createElement("path",{"className":"a","d":"M-10.815-4.37l8.74-8.911-8.374-8.545,1.929-1.953,8.35,8.545L8.2-23.779l1.929,1.953L1.758-13.281,10.5-4.37,8.569-2.441l-8.74-8.887L-8.887-2.441Z","transform":"translate(10.815 23.779)","key":1})]);
}

CloseIcon.defaultProps = {"width":"21.313","height":"21.338","viewBox":"0 0 21.313 21.338"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
